import { forwardRef } from "react";
import CarouselCardListItems from "./components/CarouselCardListItems/component";
import { PAGE_SIZES } from "../../constants";
import { CarouselCardListRef, CarouselCardListProps } from "./types";

const CarouselCardList = forwardRef<CarouselCardListRef, CarouselCardListProps>(
    (
        {
            items = [],
            featureAttributionData = {},
            maxPages = 1,
            pageSize = PAGE_SIZES.LARGE,
            carouselTitle = "",
        },
        sliderRefArray
    ) => {
        if (!items.length) return null;

        const content = [];

        const getSliderId = (id: number) => {
            return `${
                carouselTitle ? carouselTitle.replace(/\s/g, "") : ""
            }-slider-${id}`;
        };

        for (let i = 0; i < maxPages; i++) {
            const offset = i * pageSize;
            const cards = items.slice(offset, offset + pageSize);
            const key = getSliderId(i + 1);
            if (
                sliderRefArray &&
                typeof sliderRefArray !== "function" &&
                sliderRefArray.current
            ) {
                if (!sliderRefArray.current[i]) {
                    sliderRefArray.current[i] = null;
                }
            }
            content.push(
                <ul
                    key={key}
                    id={key}
                    ref={(element) => {
                        if (
                            sliderRefArray &&
                            typeof sliderRefArray !== "function" &&
                            sliderRefArray.current
                        ) {
                            sliderRefArray.current[i] = element;
                        }
                    }}
                    data-testid={key}
                >
                    <CarouselCardListItems
                        items={cards}
                        featureAttributionData={{
                            ...featureAttributionData,
                            offset,
                        }}
                    />
                </ul>
            );
        }
        return <>{content}</>;
    }
);

export default CarouselCardList;
